module.exports = __webpack_public_path__ + "img/banner-paryushan-2021.f52f24d2.jpg";